import { Phone, Star, ShieldCheck, Clock, Zap } from "lucide-react";
import { BUSINESS } from "@/data/business";
import QuoteForm from "@/components/site/QuoteForm";

const HERO_IMG =
  "/images/hero-garage-door-prosper-tx.webp";

const badges = [
  { icon: Star, label: "5-Star Rated" },
  { icon: ShieldCheck, label: "Licensed & Insured" },
  { icon: Zap, label: "Same-Day Service" },
];

export default function Hero() {
  return (
    <section id="top" className="relative bg-slate-900 text-white overflow-hidden">
      {/* Background image + overlays */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Modern residential garage door repaired by Prosper Garage Door technician"
          fetchPriority="high"
          width="1280"
          height="720"
          className="h-full w-full object-cover object-center opacity-40 lg:opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/90 to-slate-900/40" />
        <div className="absolute inset-0 bg-grid-dark opacity-60" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14 lg:py-24">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-8 items-center">
          {/* Left: value prop */}
          <div className="lg:col-span-7 animate-fade-up">
            <div className="inline-flex items-center gap-2 bg-red-600 text-white px-3 py-1.5 rounded-sm text-xs font-bold uppercase tracking-widest mb-5">
              <Clock className="h-3.5 w-3.5" /> 24/7 Emergency Service
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-balance leading-[1.05]">
              Fast, Reliable Garage Door Repair in{" "}
              <span className="text-red-600">Prosper, TX</span>
            </h1>
            <p className="mt-5 text-lg sm:text-xl text-slate-300 max-w-xl leading-relaxed">
              Broken spring, stuck door, or noisy opener? Our local technicians
              fix it fast — with upfront pricing and same-day service across
              Collin County.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href={`tel:${BUSINESS.phoneRaw}`}
                className="inline-flex items-center justify-center gap-2.5 bg-red-600 hover:bg-red-700 active:scale-[0.98] text-white font-bold text-lg px-7 py-4 rounded-sm transition-colors"
                data-testid="hero-call-button"
              >
                <Phone className="h-5 w-5" /> Call {BUSINESS.phoneDisplay}
              </a>
              <a
                href="#quote"
                className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold text-lg px-7 py-4 rounded-sm transition-colors backdrop-blur"
                data-testid="hero-quote-button"
              >
                Get a Free Quote
              </a>
            </div>

            <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3">
              {badges.map((b) => (
                <span
                  key={b.label}
                  className="inline-flex items-center gap-2 text-sm font-semibold text-slate-200"
                >
                  <b.icon className="h-4 w-4 text-red-600" /> {b.label}
                </span>
              ))}
            </div>
          </div>

          {/* Right: quote form */}
          <div className="lg:col-span-5 animate-fade-up" style={{ animationDelay: "120ms" }}>
            <QuoteForm variant="hero" />
          </div>
        </div>
      </div>
    </section>
  );
}
